import { Guid, Nillable } from '@web/utils';
import { BoxQuestionnaireQuestionOption } from './box-questionnaire-question-option';

export class BoxQuestionnaireQuestion {
  public constructor(
    private readonly data: {
      description?: Nillable<string>;
      id: Guid;
      options: BoxQuestionnaireQuestionOption[];
    },
  ) {}

  public get description(): Nillable<string> {
    return this.data.description;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get options(): BoxQuestionnaireQuestionOption[] {
    return this.data.options;
  }
}
